import { useMutation } from "@tanstack/react-query";
import type {
  OtpVerifyWithdrawalRequestData,
  OtpVerifyWithdrawalRequestError,
  OtpVerifyWithdrawalRequestResponse,
} from "@/api/cashier";
import { otpVerifyWithdrawalRequestMutation } from "@/api/cashier/@tanstack/react-query.gen";

export interface VerifyOtpWithdrawalParams {
  withdrawalRequestId: string;
  accessToken: string;
}

export interface UseOtpVerifyWithdrawalReturn {
  verifyOtpWithdrawal: (
    params: VerifyOtpWithdrawalParams
  ) => Promise<OtpVerifyWithdrawalRequestResponse>;
  isPending: boolean;
  error: OtpVerifyWithdrawalRequestError | null;
}

export const useOtpVerifyWithdrawal = (): UseOtpVerifyWithdrawalReturn => {
  const { mutateAsync, isPending, error } = useMutation(
    otpVerifyWithdrawalRequestMutation()
  );

  const verifyOtpWithdrawal = async ({
    withdrawalRequestId,
    accessToken,
  }: VerifyOtpWithdrawalParams): Promise<OtpVerifyWithdrawalRequestResponse> => {
    return await mutateAsync({
      path: {
        withdrawalRequestID: withdrawalRequestId,
      },
      body: {
        access_token: accessToken,
      },
    } as OtpVerifyWithdrawalRequestData);
  };

  return {
    verifyOtpWithdrawal,
    isPending,
    error: error as OtpVerifyWithdrawalRequestError | null,
  };
};
